const defaultState = {
  data: [],
  callParams: {},
  loading: false,
  error: false,
};

const assignedTurfs = function (state = defaultState, action) {
  switch (action.type) {
    case "SET_ASSIGNED_TURFS":
      return { ...state, data: action.data };

    case "SET_ASSIGNED_TURFS_CALL_PARAMS":
      return { ...state, callParams: action.data };

    case "SET_ASSIGNED_TURFS_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_ASSIGNED_TURFS_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default assignedTurfs;
